export const PERSONAL_INFO_ERROR_TITLES = {
  DEFAULT: 'Please fix the errors below.'
};

export const CONTINUE_BUTTON_TEXT = 'Continue';

export const CONS = {
  title: 'Let\'s look for your records',
  description: 'If you\'re helping someone else, enter their info.',
  dob: 'Date of birth',
  dob_helper: 'Enter 4 digits for year.',
  have_an_account: 'Have an account?',
  sign_in: 'Sign in',
  use_rx_label: 'Use a prescription label',
  use_phone_dob: 'Use personal info'
};

export const PHONE_DOB_FORM_LABELS = {
  PHONE_NUMBER: 'Phone number',
  DATE_OF_BIRTH: 'Date of birth'
};

export const LOOKUP_ERRORS = {
  imperva_error: {
    title: 'We can\'t look for your records right now',
    description: 'There\'s a problem with your network address.',
    suggestions: 'You might be able to fix this by:',
    suggestions_array: ['Disconnecting from VPN', 'Connecting to a different network', 'Trying to sign in again'],
    customer_care: 'For help, call us at'
  },
  tech_error: {
    title: 'Sorry, something went wrong on our end',
    description: 'You can try again now, but you might have to come back later. You can also try signing in.'
  },
  locked_error: {
    title: 'There were too many incorrect attempts',
    description: 'You\'ll need to wait 30 minutes to try again. Or you can try signing in.'
  },
  two_attempts_remaining: {
    title: 'We couldn\'t find your records',
    description: 'You can try again 2 more times.'
  },
  one_attempt_remaining: {
    title: 'We still couldn\'t find your records',
    description: 'You have 1 more try before being locked out for 30 minutes.'
  },
  swap_forms: {
    link_to_rx_label: 'Try using your prescription label',
    try_again_phone_dob: 'or enter your personal info again.',
    link_to_phone_dob: 'Try using your personal info',
    try_again_rx_label: 'or enter your prescription label again.'
  },
  registration_blocked: {
    title: 'You need to sign in through your health plan'
  },
  multiple_matches: {
    title: 'You need to sign in to continue',
    description: 'We found multiple records with your information.',
    sign_in: 'Sign in or register',
    need_help: 'Need help?',
    customer_care: 'Call us at'
  }
};

// Translation configuration for phone-dob page
export const PHONE_DOB_TRANSLATION_CONFIG = [
  { key: 'CONTINUE_BUTTON_TEXT', value: CONTINUE_BUTTON_TEXT, message: CONTINUE_BUTTON_TEXT },
  {
    key: 'PERSONAL_INFO_ERROR_TITLES',
    value: PERSONAL_INFO_ERROR_TITLES,
    message: JSON.stringify(PERSONAL_INFO_ERROR_TITLES)
  },
  { key: 'CONS', value: CONS, message: JSON.stringify(CONS) },
  { key: 'PHONE_DOB_FORM_LABELS', value: PHONE_DOB_FORM_LABELS, message: JSON.stringify(PHONE_DOB_FORM_LABELS) },
  { key: 'LOOKUP_ERRORS', value: LOOKUP_ERRORS, message: JSON.stringify(LOOKUP_ERRORS) }
];

// Helper function to process translated items
export const processPhoneDobTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  const parseObject = (fallback: any) => {
    const parsed = translatedItems[JSON.stringify(fallback)];
    if (parsed) {
      try {
        return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
      } catch {
        return fallback;
      }
    }
    return fallback;
  };

  return {
    CONTINUE_BUTTON_TEXT: translatedItems[CONTINUE_BUTTON_TEXT] || CONTINUE_BUTTON_TEXT,
    PERSONAL_INFO_ERROR_TITLES: parseObject(PERSONAL_INFO_ERROR_TITLES),
    CONS: parseObject(CONS),
    PHONE_DOB_FORM_LABELS: parseObject(PHONE_DOB_FORM_LABELS),
    LOOKUP_ERRORS: parseObject(LOOKUP_ERRORS)
  };
};
